<template>
  <div>
    <table>
      <tr>
        <td style="width:40px" valign="middle" class="text-right">
          <img :style="{ width: width, height: height }" :src="profile" alt />
        </td>
        <td valign="middle">
          <input
            type="text"
            class="form-control"
            :class="{ loading: posting_comment }"
            :disabled="posting_comment"
            :placeholder="$t('homework.writeCommentHere')"
            v-model.trim="model.comments"
            @keyup.enter.prevent="store"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'inputPublicComment',
  props: {
    referenceId: {
      type: String,
      default: null
    },
    width: {
      type: String | Number,
      default: '35px'
    },
    height: {
      type: String | Number,
      default: '35px'
    }
  },
  data() {
    return {
      // profile: 'https://miro.medium.com/max/2560/1*v3sTZbOFbLgrylXjgMO-UA.jpeg',
      posting_comment: false,
      model: {
        comments: '',
        homework_id: '',
        reference_id: null,
        comment_type_id: 1 // comment as text
      }
    }
  },
  created() {
    this.model.homework_id = parseInt(this.$route.params.id)
    this.model.reference_id = this.referenceId
  },
  computed: {
    profile() {
      return this.$store.getters.userProfile
    }
  },
  methods: {
    store() {
      if (!this.model.comments) return
      this.posting_comment = true
      this.$store
        .dispatch('eschool/homeworkCommentPublic/store', this.model)
        .then(response => {
          this.clearInput()
          this.$store.commit(
            'eschool/homeworkCommentPublic/PUSH_NEW_RECORD',
            response.data
          )
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.posting_comment = false
        })
    },
    clearInput() {
      this.model.comments = ''
    }
  }
}
</script>

<style lang="css" scoped>
table {
	width: 100%;
}
img {
  display: inline;
  border-radius: 103px;
  padding: 3px;
  object-fit: cover;
  object-position: center;
  background: #fff7f7;
}
.loading {
  background-color: #ffffff;
  background-image: url("https://techstore.sgp1.cdn.digitaloceanspaces.com/public/loading.gif");
  background-size: 25px 25px;
  background-position:right center;
  background-repeat: no-repeat;
}
</style>
